import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Gateway} from '@models/adminstration/gateway/gateway';
import {GatewaySignals} from '@models/adminstration/gateway/gateway-configuration/gateway-signals';
import {Device} from '@models/adminstration/gateway/gateway-configuration/device';
import {GATEWAY_CONFIG_DATATYPE} from '@constants/administration/gateway/gateway-constants';

@Component({
    selector: 'scitis-admin-gateway-general',
    templateUrl: './gateway-general.component.html',
    styleUrls: ['./gateway-general.component.scss'],
    standalone: false
})
export class GatewayGeneralComponent implements OnInit, OnChanges {

  @Input()
  isAdminRole = false;

  @Input()
  isSuperAdminRole = false;

  @Input()
  isTechAdminRole = false;

  @Input()
  gateway = new Gateway();

  @Input()
  gatewaySignals: GatewaySignals[] = new Array<GatewaySignals>();

  @Output()
  pushToIoTCoreEvent = new EventEmitter<any>();

  @Output()
  saveConfigurationEvent = new EventEmitter<any>();

  isAdminOrSuperAdminOrTechAdmin = false;
  UPLOAD_INTERVAL_MIN = 10;
  UPLOAD_INTERVAL_MAX = 360000;
  uploadInterval: number | string = '';
  form: UntypedFormGroup = new UntypedFormGroup({});
  formGenerated: boolean = false;

  get formControls() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.initializeComponent();
  }

  private initializeComponent(): void {
    this.isAdminOrSuperAdminOrTechAdmin = this.isAdminRole || this.isTechAdminRole || this.isSuperAdminRole;
    if (this.gatewaySignals.length === 0) {
      this.gatewaySignals.push(new GatewaySignals());
    }
    this.uploadInterval = this.handleUploadIntervalInit(this.gatewaySignals[0]);
    this.generateForm();
  }

  onSave() {
    if (!this.gatewaySignals || this.gatewaySignals.length < 1) {
      this.gatewaySignals = [new GatewaySignals()];
    }
    this.gatewaySignals[0]['@type'] = GATEWAY_CONFIG_DATATYPE;
    this.gatewaySignals[0].device = this.getDeviceDetails();
    this.saveConfigurationEvent.emit(this.gatewaySignals[0]);
  }

  onPushToIotCore() {
    this.gatewaySignals[0]['@type'] = GATEWAY_CONFIG_DATATYPE;
    this.gatewaySignals[0].device = this.getDeviceDetails();
    this.pushToIoTCoreEvent.emit();
  }

  private getDeviceDetails(): Device | null {
    this.uploadInterval = this.formControls.interval.value;
    if (this.uploadInterval === null || this.uploadInterval === '') {
      console.warn('Upload interval invalid "' + this.uploadInterval + '"');
      return null;
    }

    const parsedNumber = parseInt(String(this.uploadInterval));
    if (isNaN(parsedNumber)) {
      console.warn('Parsed upload interval value is not a number', parsedNumber);
      return null;
    }

    if (this.UPLOAD_INTERVAL_MIN > parsedNumber || this.UPLOAD_INTERVAL_MAX < parsedNumber) {
      console.warn('Parsed upload interval value ' + parsedNumber + ' is outside of allowed interval [' +
          this.UPLOAD_INTERVAL_MIN + ' - ' + this.UPLOAD_INTERVAL_MAX + ']');
      return null;
    }
    const deviceDetails = new Device();
    deviceDetails.uploadIntervalS = parsedNumber;
    return deviceDetails;
  }

  private generateForm(): void {
    this.form = new UntypedFormGroup({
      interval: new UntypedFormControl(this.uploadInterval,
          [Validators.required, Validators.min(this.UPLOAD_INTERVAL_MIN), Validators.max(this.UPLOAD_INTERVAL_MAX)])
    });
    this.formGenerated = true;
  }

  private handleUploadIntervalInit(config): number | string {
    const uploadInterval = 0;
    if (!config) {
      return uploadInterval;
    }

    if (!config.device) {
      return uploadInterval;
    }

    if (!config.device.uploadIntervalS) {
      return uploadInterval;
    }

    const uploadIntervalSeconds = parseInt(config.device.uploadIntervalS);
    if (isNaN(uploadIntervalSeconds)) {
      return uploadInterval;
    }
    return uploadIntervalSeconds;
  }

}
